import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// app: components
import Price from 'components/Price';

// assets
import CssAlacarteBookDealOverlay from './AlacarteBookDealOverlay.scss';

function AlacarteBookDealOverlay(props) {
  const { className, price, ...others } = props;
  useStyles(CssAlacarteBookDealOverlay);

  if (price) {
    const rootClassName = classNames('book-deal-overlay', className);
    return (
      <div className={rootClassName} {...others}>
        <Price
          currency={price.currency}
          amount={price.offer_price}
          originalPrice={price.list_price}
        />
      </div>
    );
  }

  return null;
}

AlacarteBookDealOverlay.propTypes = {
  className: PropTypes.string,
  price: PropTypes.shape({
    currency: PropTypes.string,
    offer_price: PropTypes.string,
    list_price: PropTypes.string,
  }),
};

AlacarteBookDealOverlay.defaultProps = {
  className: null,
  price: null,
};

export default AlacarteBookDealOverlay;
